exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "// extracted by mini-css-extract-plugin\nexport {};", ""]);

// exports
